import css from './downloadButton.module.css'
import DownloadIcon from '../../../assets/icons/download.svg?react'
import { CSSProperties, MouseEvent } from 'react'
import domUtils from '../../../utils/dom.utils.ts'

interface IProps {
  downloadFilename?: string
  downloadUrl?: string
  onClick?: (ev: MouseEvent<HTMLDivElement>) => void
  style?: CSSProperties
  iconStyle?: CSSProperties
}

const DownloadButton = (props: IProps) => {
  const handleDownload = () => {
    domUtils.downloadFile(props.downloadUrl, props.downloadFilename || 'Без названия')
  }

  return (
    <div className={css.wrapper} onClick={props.onClick || handleDownload} style={props.style}>
      <DownloadIcon className={css.icon} style={props.iconStyle} />
    </div>
  )
}

export default DownloadButton
